import axios from "axios";
import Cookies from "js-cookie";
import MobileGatewayService from "../services/mobile_auth.service";

const BASE_URL = `${process.env.REACT_APP_MOBILE_PUBLIC_BASE_URL}`;

export const axiosMobileInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export const axiosMobileAuthInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    Pragma: "no-cache",
  },
});

axiosMobileAuthInstance.interceptors.request.use(
  function (config) {
    const userToken = Cookies.get("access_token");

    if (userToken) {
      config.headers["Authorization"] = `Bearer ${userToken}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// createAuthRefreshInterceptor(axiosMobileAuthInstance, AuthService.refreshToken);

axiosMobileAuthInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      await MobileGatewayService.refreshToken(error);
      const token = Cookies.get("access_token");
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      return axiosMobileAuthInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);
